import React from 'react'
import { AuthLayout } from '@/components/auth/AuthLayout'
import { LoginForm } from '@/components/auth/LoginForm'

export const Login: React.FC = () => {
  return (
    <AuthLayout
      title="Sign In"
      description="Enter your credentials to access the admin panel"
    >
      <LoginForm />
    </AuthLayout>
  )
}